import { Chart } from '@frontend/chart/types';

import { createSingleSeriesTimeSeriesMockData } from '../../../mocks/create-time-series-mock-data';

export const SPOT_FILL_RATE_LINE_CHART_MOCK_DATA: Chart = {
    ...createSingleSeriesTimeSeriesMockData({
        days: 30,
        scale: 8,
        seriesName: 'Fill rate'
    }),
    /** Fictional PuDo SLOT capacity for preview of the reference annotation line. */
    reference: 48
};
